(function () {
    'use strict';
  
    const ZINUS_REBUY_SIZE_BUNDLE = {
      widgetIds: ['307893', '196679', '305491', '197518'],
  
      /*
       * Collection handle -> Shopify Size option value.
       *
       * Size matching only runs on these collection URLs. Product
       * pages that also embed 197518 are left on the default Rebuy
       * widget.
       */
      collectionSizes: {
        'twin-mattresses': 'Twin',
        'full-mattresses': 'Full',
        'queen-mattresses': 'Queen',
        'king-mattresses': 'King',
        'twin-size-mattresses': 'Twin',
        'full-size-mattresses': 'Full',
        'queen-size-mattresses': 'Queen',
        'king-size-mattresses': 'King',
        'twin-bedframes': 'Twin',
        'full-bedframes': 'Full',
        'queen-bedframes': 'Queen',
        'king-bedframes': 'King',
        'twin-size-bedframes': 'Twin',
        'full-size-bedframes': 'Full',
        'queen-size-bedframes': 'Queen',
        'king-size-bedframes': 'King',

        /*
         * Enable once the actual Shopify option value is confirmed
         * across Cal King-compatible products.
         *
         * Likely:
         * 'california-king-mattresses': 'Cal King'
         */
      },
  
      productTypes: {
        mattress: 'mattress',
        bed: 'beds'
      },
  
      /*
       * If true, the entire widget disappears unless we can build
       * a complete mattress + bed-frame pairing.
       */
      requireCompleteBundle: true,
  
      debug: false
    };
  
  
    /*
     * Keep track of the product set we've already transformed.
     *
     * This makes the operation idempotent if Rebuy emits ready
     * after productsChange, or if another refresh occurs.
     */
    const processedSignatures = new WeakMap();
  
  
    function log(...args) {
      if (ZINUS_REBUY_SIZE_BUNDLE.debug) {
        console.log('[Zinus Rebuy Size Bundle]', ...args);
      }
    }
  
  
    function normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase();
    }
  
  
    function getCollectionHandle() {
      const match = window.location.pathname.match(
        /^\/collections\/([^/?#]+)/
      );
  
      return match ? match[1].toLowerCase() : null;
    }
  
  
    function isSizeCollectionHandle(handle) {
      return (
        handle.indexOf('mattress') !== -1 ||
        handle.indexOf('bedframe') !== -1 ||
        handle.indexOf('bed-frame') !== -1
      );
    }


    function deriveSizeFromHandle(handle) {
      if (!isSizeCollectionHandle(handle)) {
        return null;
      }

      if (
        handle.indexOf('california-king') !== -1 ||
        handle.indexOf('cal-king') !== -1
      ) {
        return 'Cal King';
      }

      if (/\btwin\b/.test(handle)) {
        return 'Twin';
      }

      if (/\bfull\b/.test(handle)) {
        return 'Full';
      }

      if (/\bqueen\b/.test(handle)) {
        return 'Queen';
      }

      if (/\bking\b/.test(handle)) {
        return 'King';
      }

      return null;
    }


    function getRequiredSize() {
      const handle = getCollectionHandle();

      if (!handle) {
        return null;
      }

      return (
        ZINUS_REBUY_SIZE_BUNDLE.collectionSizes[handle] ||
        deriveSizeFromHandle(handle)
      );
    }
  
  
    function isTargetWidget(widget) {
      return (
        widget &&
        ZINUS_REBUY_SIZE_BUNDLE.widgetIds.indexOf(String(widget.id)) !== -1
      );
    }
  
  
    /*
     * Uses the product.options definition rather than permanently
     * assuming Size is option1.
     *
     * The current Zinus payload shows Size at position 1, but this
     * keeps the code safe for future catalog changes.
     */
    function getSizeOptionPosition(product) {
      if (!product || !Array.isArray(product.options)) {
        return null;
      }
  
      const sizeOption = product.options.find(function (option) {
        return normalize(option.name) === 'size';
      });
  
      return sizeOption ? Number(sizeOption.position) : null;
    }
  
  
    function getVariantSize(product, variant) {
      const position = getSizeOptionPosition(product);
  
      if (!position || !variant) {
        return null;
      }
  
      return variant['option' + position] || null;
    }
  
  
    function findSizeVariant(product, requiredSize) {
      if (!product || !Array.isArray(product.variants)) {
        return null;
      }
  
      const target = normalize(requiredSize);
  
      return (
        product.variants.find(function (variant) {
          return normalize(getVariantSize(product, variant)) === target;
        }) || null
      );
    }
  
  
    function getWidgetVue(widget) {
      return (
        widget &&
        widget.View &&
        widget.View.vue
      ) || null;
    }


    function variantAvailable(widget, variant) {
      if (!variant) {
        return false;
      }

      const vue = getWidgetVue(widget);

      /*
       * Preferred path.
       *
       * Rebuy documents this as checking availability using
       * inventory policy and inventory quantity.
       */
      if (vue && typeof vue.variantAvailable === 'function') {
        return vue.variantAvailable(variant);
      }

      if (typeof widget.variantAvailable === 'function') {
        return widget.variantAvailable(variant);
      }
  
      /*
       * Defensive fallback if the Rebuy API changes or this is
       * executed unexpectedly before widget methods are available.
       */
      if (variant.inventory_policy === 'continue') {
        return true;
      }
  
      if (!variant.inventory_management) {
        return true;
      }
  
      return Number(variant.inventory_quantity || 0) > 0;
    }
  
  
    function getProductGroup(product) {
      const type = normalize(product.product_type);
  
      if (
        type ===
        normalize(ZINUS_REBUY_SIZE_BUNDLE.productTypes.mattress)
      ) {
        return 'mattress';
      }
  
      if (
        type ===
        normalize(ZINUS_REBUY_SIZE_BUNDLE.productTypes.bed)
      ) {
        return 'bed';
      }
  
      return null;
    }
  
  
    /*
     * Synchronize all of the Rebuy product fields represented
     * in the payload you provided.
     *
     * This intentionally doesn't rely only on selected_variant_id.
     */
    function setSelectedVariant(product, variant, includeInBundle) {
      product.selected_variant_id = variant.id;
      product.selected_variant = variant;

      const position = getSizeOptionPosition(product);

      if (position) {
        product['option' + position] =
          variant['option' + position];
      }

      /*
       * Dynamic Bundle should include the chosen product.
       * Product widgets (197518) should keep their own selected state.
       */
      if (includeInBundle !== false) {
        product.selected = true;
      }
    }


    function syncWidgetVariantSelection(
      widget,
      products,
      product,
      variant,
      requiredSize
    ) {
      const index = getProductIndex(products, product);

      if (index === -1) {
        return;
      }

      const vue = getWidgetVue(widget);
      const sizeValue =
        getVariantSize(product, variant) || requiredSize;

      try {
        /*
         * Rebuy keeps selectVariant* on the Vue instance
         * (widget.View.vue), not on the widget wrapper.
         */
        if (vue && typeof vue.selectVariantBySize === 'function') {
          vue.selectVariantBySize(product, sizeValue, index);
          return;
        }

        if (vue && typeof vue.selectVariant === 'function') {
          product.selected_variant_id = variant.id;
          vue.selectVariant(product);
          return;
        }

        if (typeof widget.selectVariantBySize === 'function') {
          widget.selectVariantBySize(product, sizeValue, index);
        } else if (typeof widget.selectVariant === 'function') {
          widget.selectVariant(product);
        }
      } catch (error) {
        log('selectVariant failed', product.title, error);
      }
    }
  
  
    function isDynamicBundle(widget) {
      const type =
        widget &&
        widget.data &&
        widget.data.config &&
        widget.data.config.type;
  
      return type === 'dynamic_bundle';
    }
  
  
    function candidateForProduct(widget, product, requiredSize) {
      const group = getProductGroup(product);
  
      if (!group) {
        log(
          'Ignoring unsupported product type:',
          product.title,
          product.product_type
        );
  
        return null;
      }
  
      const variant = findSizeVariant(product, requiredSize);
  
      if (!variant) {
        log(
          'Rejected - missing size:',
          product.title,
          requiredSize
        );
  
        return null;
      }
  
      if (!variantAvailable(widget, variant)) {
        log(
          'Rejected - size unavailable:',
          product.title,
          requiredSize,
          variant.id,
          variant.inventory_quantity
        );
  
        return null;
      }
  
      return {
        product,
        variant,
        group
      };
    }
  
  
    function getProductIndex(products, product) {
      return products.findIndex(function (item) {
        return item && product && item.id === product.id;
      });
    }


    function productHasRequiredSize(product, requiredSize) {
      const currentSize = getVariantSize(
        product,
        product.selected_variant
      );

      return normalize(currentSize) === normalize(requiredSize);
    }


    function canApplyRequiredSize(widget, product, requiredSize) {
      const variant = findSizeVariant(product, requiredSize);

      return Boolean(
        variant && variantAvailable(widget, variant)
      );
    }


    function productsNeedSizing(widget, products, requiredSize) {
      return products.some(function (product) {
        if (!canApplyRequiredSize(widget, product, requiredSize)) {
          return false;
        }

        return !productHasRequiredSize(product, requiredSize);
      });
    }


    function getProductSignature(products, requiredSize) {
      return [
        requiredSize,
        ...products.map(function (product) {
          return [
            product.id,
            product.selected_variant_id
          ].join(':');
        })
      ].join('|');
    }
  
  
    function processWidget(widget) {
      if (!isTargetWidget(widget)) {
        return;
      }
  
      const requiredSize = getRequiredSize();
  
      /*
       * Leave these widgets alone anywhere other than configured
       * size-specific mattress and bed-frame collection pages.
       */
      if (!requiredSize) {
        return;
      }
  
      if (
        !widget.data ||
        !Array.isArray(widget.data.products) ||
        !widget.data.products.length
      ) {
        return;
      }
  
      const vue = getWidgetVue(widget);

      /*
       * Wait until Rebuy's Vue instance exists. Updating
       * widget.data alone does not refresh the dropdown UI.
       */
      if (!vue || !Array.isArray(vue.products) || !vue.products.length) {
        log('Deferring until Rebuy Vue is ready', widget.id);
        return;
      }

      const products = vue.products;

      if (!productsNeedSizing(widget, products, requiredSize)) {
        processedSignatures.set(
          widget,
          getProductSignature(products, requiredSize)
        );
        return;
      }
  
      log(
        'Evaluating widget products for',
        requiredSize,
        products
      );
  
      if (isDynamicBundle(widget)) {
        processBundleWidget(widget, requiredSize, products);
      } else {
        processProductSizeWidget(widget, requiredSize, products);
      }
    }
  
  
    /*
     * 197518 is a product widget ("Customers also bought").
     * On size collections, select the matching Size variant and
     * leave the rest of the widget alone.
     */
    function sizeAllProducts(widget, requiredSize, products, includeInBundle) {
      products.forEach(function (product, index) {
        const variant = findSizeVariant(product, requiredSize);

        if (!variant) {
          log(
            'Skipped - missing size:',
            product.title,
            requiredSize
          );
          return;
        }

        if (!variantAvailable(widget, variant)) {
          log(
            'Skipped unavailable size:',
            product.title,
            requiredSize
          );
          return;
        }

        setSelectedVariant(product, variant, includeInBundle);
        syncWidgetVariantSelection(
          widget,
          products,
          product,
          variant,
          requiredSize
        );
      });
    }


    function processProductSizeWidget(widget, requiredSize, products) {
      sizeAllProducts(widget, requiredSize, products, false);
  
      processedSignatures.set(
        widget,
        getProductSignature(widget.data.products, requiredSize)
      );
  
      log(
        'Sized product widget:',
        products.map(function (product) {
          return {
            product: product.title,
            size:
              product.selected_variant &&
              product.selected_variant.title,
            variantId: product.selected_variant_id
          };
        })
      );
    }
  
  
    function processBundleWidget(widget, requiredSize, products) {
      /*
       * Preserve Rebuy's incoming order.
       *
       * This is important: Rebuy/Data Source rules remain responsible
       * for merchandising priority.
       */
      const candidates = products
        .map(function (product) {
          return candidateForProduct(
            widget,
            product,
            requiredSize
          );
        })
        .filter(Boolean);
  
  
      const mattressCandidate = candidates.find(function (candidate) {
        return candidate.group === 'mattress';
      });
  
      const bedCandidate = candidates.find(function (candidate) {
        return candidate.group === 'bed';
      });
  
  
      const hasMattressBedPair =
        ZINUS_REBUY_SIZE_BUNDLE.requireCompleteBundle &&
        mattressCandidate &&
        bedCandidate;

      if (hasMattressBedPair) {
        const chosenCandidates = [
          mattressCandidate,
          bedCandidate
        ];

        chosenCandidates.forEach(function (candidate) {
          setSelectedVariant(
            candidate.product,
            candidate.variant
          );
        });

        const finalProducts = chosenCandidates.map(function (candidate) {
          return candidate.product;
        });

        /*
         * Keep the existing Vue-observed array instance intact.
         */
        widget.data.products.splice(
          0,
          widget.data.products.length,
          ...finalProducts
        );

        finalProducts.forEach(function (product) {
          const candidate = chosenCandidates.find(function (item) {
            return item.product.id === product.id;
          });

          if (!candidate) {
            return;
          }

          syncWidgetVariantSelection(
            widget,
            widget.data.products,
            product,
            candidate.variant,
            requiredSize
          );
        });

        log(
          'Final mattress + bed bundle:',
          finalProducts.map(function (product) {
            return {
              product: product.title,
              productType: product.product_type,
              size:
                product.selected_variant &&
                product.selected_variant.title,
              variantId: product.selected_variant_id
            };
          })
        );
      } else {
        /*
         * Collection FBT often shows multiple mattresses or other
         * pairings. Size every product for the collection handle
         * without replacing Rebuy's product list.
         */
        sizeAllProducts(widget, requiredSize, products, true);

        log(
          'Sized bundle products:',
          products.map(function (product) {
            return {
              product: product.title,
              productType: product.product_type,
              size:
                product.selected_variant &&
                product.selected_variant.title,
              variantId: product.selected_variant_id
            };
          })
        );
      }


      processedSignatures.set(
        widget,
        getProductSignature(
          widget.data.products,
          requiredSize
        )
      );
    }
  
  
    /*
     * Primary lifecycle hook.
     *
     * Rebuy explicitly documents productsChange as providing the
     * new recommendation array, including initial widget population.
     */
    function processExistingWidgets() {
      if (typeof Rebuy === 'undefined' || !Array.isArray(Rebuy.widgets)) {
        return;
      }

      Rebuy.widgets.forEach(processWidget);
    }


    document.addEventListener(
      'rebuy.productsChange',
      function (event) {
        const widget =
          event.detail && event.detail.widget;

        processWidget(widget);
      }
    );


    document.addEventListener(
      'rebuy.ready',
      function (event) {
        const widget =
          event.detail && event.detail.widget;

        processWidget(widget);
      }
    );


    document.addEventListener('rebuy.loaded', processExistingWidgets);

    document.addEventListener('rebuy.init', function (event) {
      const widget =
        event.detail && event.detail.widget;

      processWidget(widget);
    });


    /*
     * Safety net when Rebuy finished loading before this script ran.
     */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processExistingWidgets);
    } else {
      processExistingWidgets();
    }

    window.setTimeout(processExistingWidgets, 250);
    window.setTimeout(processExistingWidgets, 1000);

  })();